module.exports = __webpack_public_path__ + "static/media/marc_negroni_productions.9d9873d2.gif";